import { localStorage, indexdb } from '@/util/chrome.api'
import db from '@/util/db'

export const loadState = (key) => {
  try {
    const serializedState = window.localStorage.getItem(key)
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    console.log(err)
    console.warn('读取数据失败')
    throw err
  }
}

export const saveState = async (key, state) => {
  try {
    window.localStorage.setItem(key, state)
    // 同步给插件
    try {
      await localStorage({ type: 'setLocalStorage', key, data: state })
    } catch {
      // 不处理
    }
  } catch (err) {
    // 错误处理
    console.warn('保存数据失败')
    throw err
  }
}

export const delState = async (key) => {
  try {
    window.localStorage.removeItem(key)
    // 同步给插件
    try {
      await localStorage({ type: 'removeLocalStorage', key })
    } catch {
      // 不处理
    }
  } catch (err) {
    // 错误处理
    console.warn('保存数据失败')
    throw err
  }
}

export const dbUpdate = async (key, data) => {
  try {
    db.update(key, data)
    // 同步给插件
    try {
      await indexdb({ type: 'setIndexDb', key, data })
    } catch {
      // 不处理
    }
  } catch (err) {
    // 错误处理
    console.warn('更新indexdb数据失败')
    throw err
  }
}
